module.exports = __webpack_public_path__ + "img/happypin.4711a10a.svg";